import * as React from "react";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { useIsMobile } from "@utils/hooks";

export const TooshareToastContainer: React.FC = () => {
	const isMobile = useIsMobile();

	return (
		<StyledToastContainer
			position={isMobile ? "top-center" : "bottom-right"}
			hideProgressBar
			toastClassName="tooshare-toast"
			autoClose={3000}
			closeButton={false}
		/>
	);
};

const StyledToastContainer = styled(ToastContainer)`
	.tooshare-toast {
		padding: 0;
		background: none;
		box-shadow: 0 4px 46px 0 rgba(0, 0, 0, 0.1);
	}
	width: 290px;
	@media (max-width: 900px) {
		width: 100vw;
	}
	max-width: 100vw;
`;
